import React, { useState, useEffect } from 'react';
import { extractDataArray } from './Constants';

const Members = () => {
  const [participants, setParticipants] = useState([]);
  const [colleges, setColleges] = useState([]);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [filteredParticipants, setFilteredParticipants] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [participantSearchText, setParticipantSearchText] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Real-time college search
    const filtered = colleges.filter((college) =>
      college.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredColleges(filtered);
  }, [searchText, colleges]);

  useEffect(() => {
    // Real-time participant search
    if (selectedCollege) {
      const filtered = participants
        .filter((p) => p.college === selectedCollege)
        .filter((p) => {
          const nameMatch = p.full_name && p.full_name.toLowerCase().includes(participantSearchText.toLowerCase());
          const emailMatch = p.email && p.email.toLowerCase().includes(participantSearchText.toLowerCase());
          const phoneMatch = p.phone_number && p.phone_number.toLowerCase().includes(participantSearchText.toLowerCase());
          const idMatch = p.user_id && p.user_id.toString().includes(participantSearchText);
          return nameMatch || emailMatch || phoneMatch || idMatch;
        });
      setFilteredParticipants(filtered);
    }
  }, [participantSearchText, selectedCollege, participants]);

  const fetchData = async () => {
    try {
      // Fetch participants from the API
      const participantsRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}/profile/read`);
      const rawData = await participantsRes.json();
      const participantsData = extractDataArray(rawData);
      setParticipants(participantsData);

      // Extract unique colleges from participants
      const uniqueColleges = [...new Set(participantsData.map(p => p.college).filter(Boolean))];
      setColleges(uniqueColleges);
      setFilteredColleges(uniqueColleges);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleViewListClick = (college) => {
    setSelectedCollege(college);
    const filtered = participants.filter((p) => p.college === college);
    setFilteredParticipants(filtered);
    setParticipantSearchText('');
  };

  const handleBack = () => {
    setSelectedCollege(null);
    setFilteredParticipants([]);
  };

  return (
    <div className="main">
      <div className="report-container">
        {!selectedCollege ? (
          <>
            {/* Colleges Section */}
            <div className="report-header">
              <h1 className="recent-Articles">Colleges</h1>
              <div className="search-container">
                <input
                  type="text"
                  placeholder="Search by college..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="search-input"
                />
              </div>
            </div>

            <div className="report-body">
              <table className="report-table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>College</th>
                    <th>Total Members</th>
                    <th>View List</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredColleges.map((college, index) => {
                    const totalMembers = participants.filter(
                      (p) => p.college === college
                    ).length;
                    return (
                      <tr key={college}>
                        <td>{index + 1}</td>
                        <td>{college}</td>
                        <td>{totalMembers}</td>
                        <td>
                          <button className="open-form-btn" onClick={() => handleViewListClick(college)}>
                            View List
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <>
            {/* Participants Section */}
            <div className="report-header">
              <h3>
                Members
              </h3>

              <div className="search-container">
                <input
                  type="text"
                  placeholder="Search by Name, Email, Phone, or ID"
                  value={participantSearchText}
                  onChange={(e) => setParticipantSearchText(e.target.value)}
                  className="search-input"
                />&nbsp;
                <button onClick={handleBack} className="back-button">
                  Back
                </button>
              </div>
            </div>

            <div className="report-body">
              <table className="report-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>College</th>
                    <th>Department</th>
                    <th>Year of Study</th>
                    <th>Skills</th>
                    <th>Bio</th>
                    <th>Profile Image</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredParticipants.map((p) => (
                    <tr key={p.user_id}>
                      <td>{p.user_id}</td>
                      <td>{p.full_name}</td>
                      <td>{p.email}</td>
                      <td>{p.phone_number}</td>
                      <td>{p.college}</td>
                      <td>{p.department}</td>
                      <td>{p.year_of_study}</td>
                      <td>{p.skills}</td>
                      <td>{p.bio}</td>
                      <td>
                        {p.profile_image && <img src={`https://ethiccraft.org/uploads/${p.profile_image}`} alt="Profile" width="50" />}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Members;